import React, { FC } from "react";
import StepItem from "./steps/step-item";

const steps = [
  {
    label: "Datos de la",
    label2: "empresa",
    id: "COMPANY_DATA",
    index: 0,
  },
  {
    id: "SEPARATOR",
  },
  {
    label: "Persona de",
    label2: "contacto",
    id: "MAIN_CONTACT",
    index: 1,
  },
  {
    id: "SEPARATOR",
  },
  {
    label: "Bienvenido/a",
    id: "SUCCESSFUL_REGISTER",
    index: 2,
  },
];

interface Props {
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
}

const Steps: FC<Props> = ({ currentStep, setCurrentStep }) => {
  return (
    <div
      className="mt-8 grid gap-1"
      style={{
        gridTemplateColumns: "1fr  60px 1fr 60px 1fr ",
      }}
    >
      {steps.map((item, index) => (
        <StepItem
          item={item}
          key={index}
          currentStep={currentStep}
          index={item.index as number}
          setCurrentStep={setCurrentStep}
        />
      ))}
    </div>
  );
};

export default Steps;
